export const environment = {
    API_ADDRESS: 'https://api.stage.infinitform.com',
    FRONTEND_ADDRESS: 'https://cabinet.stage.infinitform.com',
    EDITOR_ADDRESS: 'https://editor.stage.infinitform.com',
    SOCKET_ADDRESS: 'wss://wss.stage.infinitform.com/stage',
    API_STORAGE_MODE: 's3',
    PRODUCTION: false,
    ENV_LABEL: 'STAGE',
    SUBSCRIPTIONS_ENABLED: true,   // Enable subscription feature checks (set to false to grant all features)
    SUBSCRIPTION_DEBUG: false,     // Enable subscription debug panel
    CAD_ADMIN_ONLY: true,          // Enable CAD editor only for admin users
    CAD_EDITOR: true,              // Enable CAD editor
};
